import React, { useState, useEffect } from 'react'
import fire from './Firebase'
import icoweb from './assets/web.png'
import icoios from './assets/ios.png'
import icoandroid from './assets/android.png'
import { BsChevronCompactDown, BsChevronCompactUp } from "react-icons/bs";
import Fade from 'react-reveal/Fade';
import Slide from 'react-reveal/Slide';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
// import icoYarn from './assets/yarn.png'

function Work(props) {
    const [icoYarn, setIcoYarn] = useState('')
    const [ssModal, setSSmodal] = useState(false)
    const [icoGym, setIcoGym] = useState('')
    const [icoDashboard, setIcoDashboard] = useState('')
    const [icoFanaticFanbase, setIcoFanaticFanbase] = useState('')
    const [icoGaneshSofa, setIcoGaneshSofa] = useState('')
    const [icoMyLampStore, setIcoMyLampStore] = useState('')
    const [icoIkaiAsai, setIcoIkaiAsai] = useState('')
    const [icoAnim, setIcoAnim] = useState('')
    const [icoRobot, setIcoRobot] = useState('')
    const [icoSanchStay, setIcoSanchStay] = useState('')
    const [icoMH, setIcoMH] = useState('')
    const [icoEcomm, setIcoEcomm] = useState('')
    const [icoBrb, setIcoBrb] = useState('')
    const [icoCS, setIcoCS] = useState('')
    const [icoWarlands, setIcoWarlands] = useState('')
    const [icoElec, setIcoElec] = useState('')
    const [icoKayakalpQuiz, setIcoKayakalpQuiz] = useState('')
    const [ssPhotos, setSSPhotos] = useState([])
    const themeColors = props.themeColors
    const [whichExtend, setWhichExtend] = useState("Underground Waifus")
    const [icoNakashi, setIcoNakashi] = useState("")
    const [icoHopar, setIcoHopar] = useState("")


    // const [extendOpt, setExpendOpt] = useState('none')
    const darkMode = props.darkMode

    useEffect(() => {
        if (ssModal) {
            let data = []
            var itemsProcessed = 0;
            function callback() {
                setSSPhotos(data)
            }
            var listRef = fire.storage().ref().child(`ss/${whichExtend}`);
            listRef.listAll().then(function (res) {
                res.items.forEach(function (itemRef, i, arr) {
                    let fullname = itemRef.name
                    itemRef.getDownloadURL().then(function (url) {
                        itemsProcessed++
                        data.push({ url: url, name: fullname })
                        if (itemsProcessed === arr.length) {
                            callback()
                        }
                    })
                });
            }).catch(function (error) {
                console.log(error)
            })
        }
    }, [ssModal])

    useEffect(() => {
        fire.storage().ref('assets/python.png').getDownloadURL().then((url) => {
            setIcoYarn(url)
        })

        fire.storage().ref('assets/anim.png').getDownloadURL().then((url) => {
            setIcoAnim(url)
        })

        fire.storage().ref('assets/gym.png').getDownloadURL().then((url) => {
            setIcoGym(url)
        })

        fire.storage().ref('assets/ganeshSofa.png').getDownloadURL().then((url) => {
            setIcoGaneshSofa(url)
        })

        fire.storage().ref('assets/fanaticFanbase.png').getDownloadURL().then((url) => {
            setIcoFanaticFanbase(url)
        })

        fire.storage().ref('assets/robot.png').getDownloadURL().then((url) => {
            setIcoRobot(url)
        })

        fire.storage().ref('assets/ikaiasai.png').getDownloadURL().then((url) => {
            setIcoIkaiAsai(url)
        })

        fire.storage().ref('assets/kayakalpquiz.png').getDownloadURL().then((url) => {
            setIcoKayakalpQuiz(url)
        })

        fire.storage().ref('assets/sanchstay.png').getDownloadURL().then((url) => {
            setIcoSanchStay(url)
        })

        fire.storage().ref('assets/myLampStore.png').getDownloadURL().then((url) => {
            setIcoMyLampStore(url)
        })

        fire.storage().ref('assets/dashboard.png').getDownloadURL().then((url) => {
            setIcoDashboard(url)
        })

        fire.storage().ref('assets/hopar.png').getDownloadURL().then((url) => {
            setIcoHopar(url)
        })

        fire.storage().ref('assets/brb.png').getDownloadURL().then((url) => {
            setIcoBrb(url)
        })

        fire.storage().ref('assets/ecomm.png').getDownloadURL().then((url) => {
            setIcoEcomm(url)
        })

        fire.storage().ref('assets/Logo.png').getDownloadURL().then((url) => {
            setIcoCS(url)
        })

        fire.storage().ref('assets/elec.png').getDownloadURL().then((url) => {
            setIcoElec(url)
        })

        fire.storage().ref('assets/logo.ico').getDownloadURL().then((url) => {
            setIcoMH(url)
        })

        fire.storage().ref('assets/warlands.png').getDownloadURL().then((url) => {
            setIcoWarlands(url)
        })

        fire.storage().ref('assets/minilogo.webp').getDownloadURL().then((url) => {
            setIcoNakashi(url)
        })
    })

    const worklList = {
        web: [
            { name: 'Underground Waifus', ico: '/waifus.webp', url: 'https://undergroundwaifus.com', description: `Underground Waifus | Unique TCG for Gamers & Collectors. (NextJS)`, ss: '' },
            { name: 'Underground Waifus Marketplace', ico: '/waifus.webp', url: 'https://marketplace.undergroundwaifus.com', description: `Underground Waifus | Unique TCG for Gamers & Collectors. (NextJS)`, ss: '' },
            { name: 'Warlands NFT', ico: icoWarlands, url: 'https://www.warlands.io', description: `Warlands is the e-Sport NFT (Non-Fungible Token) Battle Royale Game. (React JS)`, ss: '' },
            { name: 'Nakashi NFT Manga', ico: icoNakashi, url: 'https://nakashi.world', description: `Nakashi the creator of FTE-PTC (Free to Enjoy - Pay to Collect) concept. (NextJS)`, ss: '' },
            { name: 'BRB Chips', ico: icoBrb, url: 'https://www.brbchips.com', description: `BRB is a chips manufacturing company. Entire website is built on custom HTML, CSS and JavaScript code. E-commerce functionality part has used by Shopify in which I have installed my very own custom logics.`, ss: '' },
            { name: 'BRB Game', ico: icoBrb, url: 'https://brbgame.netlify.app/', description: `Brb is a chips manufacturing company. This is a web game that can be played by scanning the QR code on the back of the BRB chips packet. Two randomly lucky winners are chosen each week after the game is played and are automatically emailed. All this automation is built on Google cloud functions. I have also made this separately for portfolio. Technology used - Next.js (React.js), Firebase, Google cloud functions, Node.js, Nodemailer. `, ss: '' },
            { name: 'TheRedTools', ico: icoAnim, url: 'https://theredtools.netlify.app/', description: `TheRedTools is an online tool that download Photos, Videos, Profile and DP (Display Picture) of Instagram using Python Automation (No API). Technology used - React.js (Next.js), Node.js, Socket.io, Selenium(Python).`, ss: '' },
            { name: 'IkaiAsai', ico: icoIkaiAsai, url: 'https://www.ikaiasai.com', description: 'IkaiAsai is an E-commerce website that is built on Shopify, in which many pages have been made by me are About, Contact, Mood-Page, Our team, Retailers, Faq, Bespoke, Bespoke Ashiesh, Events-Page, Collaborators, Gift-card, Corporate-gift. And many theme modifications. ' },
            { name: 'Dashboard Design Sample', ico: icoDashboard, url: 'https://rapid-quest.netlify.app/', description: 'Responsive Dashboard Design.' },
            { name: 'E-commerce Design Sample', ico: icoEcomm, url: 'https://affinity-assignment.netlify.app/', description: 'Responsive E-commerce Design.' },
            // { name: 'Election Poll Booth Analysis', ico: icoElec, url: 'https://swing.chaudharyrahulbjp.in/', description: `Election Poll Booth Analysis is a confidential project. It is a web-based Election tool in which election data is visualized like Political Parties comparison using Bar, Pie, Area, Line Chart and Booth comparison as well. Also, we can add a city or village with notes and tags in it. These can be searched with village/city name, booth name, booth number, tag name in the dashboard. Technology used - Python, NextJS, Firebase`, ss: true },
            { name: 'Mathura Help', ico: icoMH, url: 'https://mathurahelp.in/', description: `mathurahelp.in was created during the corona virus crisis where people can help each other. Technology used - React.js, Firebase.`, ss: '' },
            // { name: 'Craft Spirits', ico: icoCS, url: 'https://craft-spirits.netlify.app/', description: `Under Development`, ss: '' },
            { name: 'Responsive Design Sample', ico: icoMH, url: 'https://aesopclone.netlify.app', description: `Responsive Design Sample.`, ss: '' },
            // { name: 'SanchStay', ico: icoSanchStay, url: 'https://www.sanchstay.com', description: 'SanchStay is an accommodation website built in React.js. Technologies used – React.js, Firebase, React-router.' },
            { name: 'Kayakalp Quiz', ico: icoKayakalpQuiz, url: 'https://kayakalpquiz.netlify.com', description: 'Kayakalp Quiz is a quiz web application built in React.js. Technologies used - React.js, Firebase.' },
            // { name: 'My Lamp Store', ico: icoMyLampStore, url: 'https://mylampstore.netlify.com', description: 'My Lamp Store is an E-commerce website which is built on React.js (Gatsby) for demo purpose.' },
            // { name: 'Fanatic Fanbase', ico: icoFanaticFanbase, url: 'https://fanatic.netlify.com', description: 'Fanatic Fanbase is a web app created for the purpose of selling to Instagram Models/Influencers, In which they can put their bio data, contact details, Photos (without quality loss) and many more things. Technology used - React.js, Firebase.' },
            // { name: 'Ganesh Sofa', ico: icoGaneshSofa, description: 'Ganesh Sofa is an E-commerce website which is built on React.js (Next.js) for demo purpose.', url: 'https://ganeshsofa.netlify.com' },
        ],

        ios: [
            { name: 'Hopar ', ico: icoHopar, description: 'By Hopar app you can create a party meet, join a party or request a party near you using GPS. Other things you can do like chatting, share meet, party contribution. Technologies used - CapacitorJS, NextJS, Firebase, Google map, GPS', url: "https://apps.apple.com/tr/app/hopar-create-discover-meets/id6444642414" },
            { name: 'Iron Kingdom Gym', ico: icoGym, description: 'Iron Kingdom Gym is an inventory management iOS app where the owner/trainer of the gym can know the status of its members whether they diposited their fees or not, active or not. Along with this, they can also know the status of their equipment, which one needs to be repaired. Technology used - React Native, Firebase.', ss: true }
        ],

        android: [
            { name: 'Hopar', ico: icoHopar, description: 'By Hopar app you can create a party meet, join a party or request a party near you using GPS. Other things you can do like chatting, share meet, party contribution. Technologies used - CapacitorJS, NextJS, Firebase, Google map, GPS', url: "https://play.google.com/store/apps/details?id=com.hopar.app" },
            { name: 'Iron Kingdom', ico: icoGym, description: 'Iron Kingdom is an inventory management Android app where the owner/trainer of the gym can know the status of its members whether they diposited their fees or not, active or not. Along with this, they can also know the status of their equipment, which one needs to be repaired. Technology used - React Native, Firebase.', ss: true }
        ],
        automation: [{ name: 'Instagram Counter', ico: icoYarn, description: "Instagram Counter is an automation tool that is tailored to my client's needs. It counts likes, shares and views of instagram posts and put them in an Excel sheet. Technology used - Python Selenium." },
        { name: 'Instagram Comment Filter', ico: icoYarn, description: "Instagram Comment Filter is an automation tool that is tailored to my client's needs. It matches the Instagram post comments from the given username list and find out who has commented and which not. And fills this information in an Excel file. Technology used - Python Selenium." }
        ]
    }

    const extend = (e) => {
        // if (e === whichExtend) {
        //     setWhichExtend('')
        // } else 
        setWhichExtend(e)

        // setExpendOpt('flex')
        // if (whichExtend === e) {
        //     setExpendOpt('flex')
        // } else setExpendOpt('none')
        // if (extendOpt === 'flex') {
        //     setExpendOpt('flex')
        // } else setExpendOpt('flex')
    }
    return (
        <div style={{ flex: 1, overflow: 'auto', height: 'auto' }}>
            <div>
                <p><span style={{ marginRight: 5 }}>
                    <img style={{ height: 10, width: 10 }} alt="" src={icoweb} />
                </span>Web Apps/Games/Sites/Pages</p>
                {worklList.web.map((items) =>
                    <div onClick={() => extend(items.name)} key={items.name} style={{ display: 'flex', backgroundColor: darkMode ? themeColors.darkOn.container.secondary : themeColors.darkOff.container.secondary, height: '100%', marginBottom: 5, marginTop: 5, cursor: '', flexDirection: 'column' }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ flex: .3, display: 'flex', justifyContent: 'center', marginTop: 10 }}>
                                <img alt="img" style={{ height: 30 }} src={items.ico} />
                            </div>
                            <div style={{ flex: 1, overflow: 'hidden', display: 'flex', alignItems: 'center', wordWrap: 'break-word', flexDirection: 'column' }}>
                                <p style={{ marginTop: 10, marginBottom: 5 }}>{items.name}</p>
                            </div>
                        </div>
                        <div style={{ textAlign: 'center', cursor: 'pointer' }}>
                            {
                                whichExtend === items.name ? ""
                                    // <Fade bottom>
                                    //     <BsChevronCompactUp style={{ fontSize: 25, margin: 0, alignSelf: 'center' }} />
                                    // </Fade>
                                    :
                                    <Fade top>
                                        <BsChevronCompactDown style={{ fontSize: 25, margin: 0, alignSelf: 'center' }} />
                                    </Fade>
                            }
                        </div>
                        <Fade top duration={500}>
                            <div style={{ display: whichExtend === items.name ? 'flex' : 'none', flexDirection: 'column', height: '100%', marginBottom: 30, marginTop: 10 }}>
                                <p className='smallTxt' style={{ fontSize: 11, color: darkMode ? themeColors.darkOn.textColor1 : themeColors.darkOff.textColor1, padding: '0 10px' }}>{items.description}</p>

                                {
                                    items.url ?
                                        <div>
                                            <p style={{ margin: 0, textAlign: 'center' }}>URL - <span style={{ color: darkMode ? '#00acee' : '#00acee', cursor: 'pointer' }}><a style={{ textDecoration: 'none', color: 'inherit' }} target='__blank' href={items.url}>{items.url}</a></span></p>
                                            {
                                                items.name === 'BRB Game' ?
                                                    <p style={{ margin: 0, textAlign: 'center', marginTop: 10 }}>Live URL - <span style={{ color: darkMode ? '#00acee' : '#00acee', cursor: 'pointer' }}><a style={{ textDecoration: 'none', color: 'inherit' }} target='__blank' href="https://scan2win.brbchips.com/">https://scan2win.brbchips.com/</a></span></p>
                                                    :
                                                    items.name === 'TheRedTools' ?
                                                        <p style={{ margin: 0, textAlign: 'center', marginTop: 10 }}>Test URL - <span style={{ color: darkMode ? '#00acee' : '#00acee', cursor: 'pointer' }}><a style={{ textDecoration: 'none', color: 'inherit' }} target='__blank' href="https://theredtools.netlify.app/">https://theredtools.netlify.app/</a></span></p>
                                                        :
                                                        items.name === 'Mathura Help' ?
                                                            <p style={{ margin: 0, textAlign: 'center', marginTop: 10 }}>Test URL - <span style={{ color: darkMode ? '#00acee' : '#00acee', cursor: 'pointer' }}><a style={{ textDecoration: 'none', color: 'inherit' }} target='__blank' href="https://mathurahelp.netlify.app/">https://mathurahelp.netlify.app/</a></span></p>
                                                            : ''
                                            }
                                        </div>
                                        :
                                        <p style={{ margin: 0 }}></p>
                                }

                                {
                                    items.ss ?
                                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
                                            <Fade right>
                                                <div onClick={() => setSSmodal(true)} style={{ border: `.1px solid ${darkMode ? 'white' : 'grey'}`, height: 40, width: 100, display: 'flex', justifyContent: 'center', alignContent: 'center', cursor: 'pointer' }}>
                                                    <p>Screenshots</p>
                                                </div>
                                            </Fade>
                                        </div>
                                        :
                                        <p style={{ margin: 0 }}></p>
                                }


                            </div>
                        </Fade>
                    </div>)}
            </div>

            <div>
                <p><span style={{ marginRight: 5 }}>
                    <img style={{ height: 12, width: 12 }} alt="" src={icoios} />
                </span>iOS Apps</p>
                {worklList.ios.map((items) =>
                    <div onClick={() => extend(items.name)} key={items.name} style={{ display: 'flex', backgroundColor: darkMode ? themeColors.darkOn.container.secondary : themeColors.darkOff.container.secondary, height: '100%', marginBottom: 5, marginTop: 5, cursor: '', flexDirection: 'column' }}>
                        <div style={{ display: 'flex', flexDirection: "column" }}>
                            <div style={{ flex: .3, display: 'flex', justifyContent: 'center', marginTop: 10 }}>
                                <img alt="img" style={{ height: 30 }} src={items.ico} />
                            </div>
                            <div style={{ flex: 1, overflow: 'hidden', display: 'flex', alignItems: 'center', wordWrap: 'break-word', flexDirection: 'column' }}>
                                <p style={{ marginTop: 10, marginBottom: 5 }}>{items.name}</p>
                            </div>
                        </div>
                        <div style={{ textAlign: 'center', cursor: 'pointer' }}>
                            {
                                whichExtend === items.name ?
                                    ""
                                    // <Fade bottom>
                                    //     <BsChevronCompactUp style={{ fontSize: 25, margin: 0, alignSelf: 'center' }} />
                                    // </Fade>
                                    :
                                    <Fade top>
                                        <BsChevronCompactDown style={{ fontSize: 25, margin: 0, alignSelf: 'center' }} />
                                    </Fade>
                            }
                        </div>
                        <Fade top duration={500}>

                            <div style={{ display: whichExtend === items.name ? 'flex' : 'none', flexDirection: 'column', height: '100%', marginBottom: 30, marginTop: 10 }}>
                                <p className='smallTxt' style={{ fontSize: 11, color: darkMode ? themeColors.darkOn.textColor1 : themeColors.darkOff.textColor1, padding: "0 10px" }}>{items.description}</p>

                                {
                                    items.url ?
                                        <p style={{ margin: 0, textAlign: 'center' }}>URL - <span style={{ color: darkMode ? '#00acee' : '#00acee', cursor: 'pointer' }}><a style={{ textDecoration: 'none', color: 'inherit' }} target='__blank' href={items.url}>{items.url}</a></span></p>
                                        :
                                        <p style={{ margin: 0 }}></p>
                                }

                                {
                                    items.ss ?
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            <Fade right>
                                                <div onClick={() => setSSmodal(true)} style={{ border: `.1px solid ${darkMode ? 'white' : 'grey'}`, height: 40, width: 100, display: 'flex', justifyContent: 'center', alignContent: 'center', cursor: 'pointer' }}>
                                                    <p>Screenshots</p>
                                                </div>
                                            </Fade>
                                        </div>
                                        :
                                        <p style={{ margin: 0 }}></p>
                                }


                            </div>
                        </Fade>
                    </div>)}
            </div>

            <div>
                <p><span style={{ marginRight: 5 }}>
                    <img style={{ height: 12, width: 12 }} alt="" src={icoandroid} />
                </span>Android Apps</p>
                {worklList.android.map((items) =>
                    <div onClick={() => extend(items.name)} key={items.name} style={{ display: 'flex', backgroundColor: darkMode ? themeColors.darkOn.container.secondary : themeColors.darkOff.container.secondary, height: '100%', marginBottom: 5, marginTop: 5, cursor: '', flexDirection: 'column' }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ flex: .3, display: 'flex', justifyContent: 'center', marginTop: 10 }}>
                                <img alt="img" style={{ height: 30 }} src={items.ico} />
                            </div>
                            <div style={{ flex: 1, overflow: 'hidden', display: 'flex', alignItems: 'center', wordWrap: 'break-word', flexDirection: 'column' }}>
                                <p style={{ marginTop: 10, marginBottom: 5 }}>{items.name}</p>
                            </div>
                        </div>
                        <div style={{ textAlign: 'center', cursor: 'pointer' }}>
                            {
                                whichExtend === items.name ? ""
                                    // <Fade bottom>
                                    //     <BsChevronCompactUp style={{ fontSize: 25, margin: 0, alignSelf: 'center' }} />
                                    // </Fade>
                                    :
                                    <Fade top>
                                        <BsChevronCompactDown style={{ fontSize: 25, margin: 0, alignSelf: 'center' }} />
                                    </Fade>
                            }
                        </div>
                        <Fade top duration={500}>
                            <div style={{ display: whichExtend === items.name ? 'flex' : 'none', flexDirection: 'column', height: '100%', marginBottom: 30, marginTop: 10 }}>
                                <p className='smallTxt' style={{ fontSize: 11, color: darkMode ? themeColors.darkOn.textColor1 : themeColors.darkOff.textColor1, padding: "0 10px" }}>{items.description}</p>

                                {
                                    items.url ?
                                        <p style={{ margin: 0, textAlign: 'center' }}>URL - <span style={{ color: darkMode ? '#00acee' : '#00acee', cursor: 'pointer' }}><a style={{ textDecoration: 'none', color: 'inherit' }} target='__blank' href={items.url}>{items.url}</a></span></p>
                                        :
                                        <p style={{ margin: 0 }}></p>
                                }

                                {
                                    items.ss ?
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            <Fade right>
                                                <div onClick={() => setSSmodal(true)} style={{ border: `.1px solid ${darkMode ? 'white' : 'grey'}`, height: 40, width: 100, display: 'flex', justifyContent: 'center', alignContent: 'center', cursor: 'pointer' }}>
                                                    <p>Screenshots</p>
                                                </div>
                                            </Fade>
                                        </div>
                                        :
                                        <p style={{ margin: 0 }}></p>
                                }


                            </div>
                        </Fade>
                    </div>)}
            </div>

            <div>
                <p><span style={{ marginRight: 5 }}>
                    <img style={{ height: 12, width: 12 }} alt="" src={icoRobot} />
                </span>Automation/Testing/ML/AI</p>
                {worklList.automation.map((items) =>
                    <div onClick={() => extend(items.name)} key={items.name} style={{ display: 'flex', backgroundColor: darkMode ? themeColors.darkOn.container.secondary : themeColors.darkOff.container.secondary, height: '100%', marginBottom: 5, marginTop: 5, cursor: '', flexDirection: 'column' }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ flex: .3, display: 'flex', justifyContent: 'center', marginTop: 10 }}>
                                <img alt="img" style={{ height: 30, width: 30 }} src={items.ico} />
                            </div>
                            <div style={{ flex: 1, overflow: 'hidden', display: 'flex', alignItems: 'center', wordWrap: 'break-word', flexDirection: 'column' }}>
                                <p style={{ marginTop: 10, marginBottom: 5 }}>{items.name}</p>
                            </div>
                        </div>
                        <div style={{ textAlign: 'center', cursor: 'pointer' }}>
                            {
                                whichExtend === items.name ? ""
                                    // <Fade bottom>
                                    //     <BsChevronCompactUp style={{ fontSize: 25, margin: 0, alignSelf: 'center' }} />
                                    // </Fade>
                                    :
                                    <Fade top>
                                        <BsChevronCompactDown style={{ fontSize: 25, margin: 0, alignSelf: 'center' }} />
                                    </Fade>
                            }
                        </div>
                        <Fade top duration={500}>
                            <div style={{ display: whichExtend === items.name ? 'flex' : 'none', flexDirection: 'column', height: '100%', marginBottom: 30, marginTop: 10 }}>
                                <p className='smallTxt' style={{ fontSize: 11, color: darkMode ? themeColors.darkOn.textColor1 : themeColors.darkOff.textColor1, padding: "0 10px" }}>{items.description}</p>

                                {
                                    items.url ?

                                        <p style={{ margin: 0, textAlign: 'center' }}>URL - <span style={{ color: darkMode ? '#00acee' : '#00acee', cursor: 'pointer' }}><a style={{ textDecoration: 'none', color: 'inherit' }} target='__blank' href={items.url}>{items.url}</a></span></p>

                                        :
                                        <p style={{ margin: 0 }}></p>
                                }

                                {
                                    items.ss ?
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            <Fade right>
                                                <div style={{ border: '1px solid white', height: 70, width: 70 }}>

                                                </div>
                                            </Fade>
                                            <Fade right delay={150}>
                                                <div style={{ border: '1px solid white', height: 70, width: 70, marginLeft: 2 }}></div>
                                            </Fade>
                                            <Fade right delay={200}>
                                                <div style={{ border: '1px solid white', height: 70, width: 70, marginLeft: 2 }}></div>
                                            </Fade>
                                        </div>
                                        :
                                        <p style={{ margin: 0 }}></p>
                                }


                            </div>
                        </Fade>
                    </div>)}
            </div>
            <div style={{ display: ssModal ? 'flex' : 'none', position: 'fixed', top: 0, right: 0, left: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,10)', flexDirection: 'column', overflow: 'auto', alignItems: 'center', paddingBottom: 50 }}>
                <div onClick={() => setSSmodal(false)} style={{ position: 'fixed', bottom: 30, color: 'black' }}>
                    <div onClick={() => setSSPhotos([])} style={{ borderRadius: 999, backgroundColor: 'rgba(255,255,255,10)', border: '1px solid black', width: 100, display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                        <p><strong>CLOSE</strong></p>
                    </div>
                </div>
                {ssPhotos.map((items) =>
                    <div style={{ marginTop: 50, border: '1px solid white' }} key={items.url}>
                        <img style={{ maxWidth: 300 }} src={items.url} />
                    </div>
                )}
            </div>
        </div>
    )
}

export default Work